import React from "react";
import Traec from "traec";
import { ActionButton } from "./button";

const respondInvite = (invite, accept) => {
  let status = accept ? "accepted" : "rejected";
  let projectId = invite.getInPath("project_discipline.project.uid");
  let inviteId = invite.get("uid");
  let fetch = new Traec.Fetch("project_invite", "put", { projectId, inviteId });
  fetch.updateFetchParams({
    preFetchHook: (body) => ({ status }),
    postSuccessHook: () => {
      location.reload();
    },
  });
  fetch.dispatch();
};

function AcceptRejectButtons({ invite, isRequest }) {
  if (isRequest) {
    return (
      <ActionButton
        text="Awaiting colleague approval"
        onClickHandler={(e) => {
          alert(
            "This request is pending approval from a colleague.  Contact your colleague or support for assistance in approving this request."
          );
        }}
      />
    );
  }

  return (
    <React.Fragment>
      <ActionButton color="success" text="Accept" onClickHandler={(e) => respondInvite(invite, true)} />
      <ActionButton color="danger" text="Reject" onClickHandler={(e) => respondInvite(invite, false)} />
    </React.Fragment>
  );
}

export default function ProjectInviteItem(props) {
  let { index: i, invite } = props;

  if (!invite || !invite?.getInPath("project_discipline.project.name")) {
    return null;
  }

  return (
    <div className="list-group-item list-group-item-action" key={i}>
      <div className="d-flex justify-content-between align-items-center">
        <div className="flex-grow-1">
          <div className="row">
            <div className="col-sm-8">
              <h6 className="mb-1 font-weight-bold text-dark">
                {invite.getIn(["project_discipline", "project", "name"])}
              </h6>
              <p className="mb-0 text-muted small">
                Role: {invite.getIn(["project_discipline", "auth", "name"]) || "Member"}
              </p>
            </div>
          </div>
        </div>
        <div className="ml-3">
          <AcceptRejectButtons {...props} isRequest={invite.get("is_request")} />
        </div>
      </div>
    </div>
  );
}
